


import { validateRoles } from '@/utils/common-utils';

export default {
  render(): any {
    return validateRoles(this.$attrs.all, this.$attrs.any) ? this.$slots.default : null;
  },
};

